import { FC } from 'react';
import styled from 'styled-components';

import { media } from '@/shared/components';
import { Title } from '@/shared/uikit/Title';

type ModalTitle = {
  title: string;
};

export const ModalTitle: FC<ModalTitle> = ({ title }) => (
  <Container>
    <Title bold size={16}>
      {title}
    </Title>
  </Container>
);

const Container = styled.div`
  padding: 18px 24px;

  ${media.sm} {
    padding: 16px 16px 16px 0;
  }
`;
